var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 28,
    viewBox: "0 0 161 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#VR_svg__clip0_224_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.05 25.153l-.958-13.135-4.114 12.507h-3.371l-4.114-12.547-.998 13.165h-3.76l1.372-19.06h3.815v.025l.932-.025 4.444 13.465L71.71 6.083l.932.025v-.025h3.785l1.397 19.06-3.775.01zM87.794 22.136c1.785 0 2.688-.628 3.32-1.78l3.098 2.054c-1.122 1.646-2.993 3.097-6.528 3.097-4.688 0-7.735-3.261-7.735-7.565a7.48 7.48 0 017.48-7.57 7.24 7.24 0 017.436 7.266 11.06 11.06 0 01-.085 1.536H83.93a3.755 3.755 0 003.865 2.962zm3.236-5.62c-.384-1.895-1.646-3.072-3.49-3.072-1.846 0-3.237 1.097-3.646 3.072h7.136zM112.094 5.106v20.047h-3.755v-1.496a5.88 5.88 0 01-4.443 1.835c-4.169 0-7.186-3.261-7.186-7.565 0-4.303 2.932-7.57 7.076-7.57a5.985 5.985 0 014.249 1.59V5.107h4.059zM108.2 17.962c0-2.359-1.496-3.99-3.731-3.99-2.234 0-3.73 1.701-3.73 3.99s1.566 3.99 3.73 3.99c2.165 0 3.731-1.651 3.731-3.99zM114.782 5.994a2.647 2.647 0 012.648-2.648 2.649 2.649 0 11-2.648 2.648zm.604 4.687h4.059v14.462h-4.059V10.681zM122.053 17.962a7.44 7.44 0 012.191-5.425 7.455 7.455 0 015.434-2.17c3.92 0 6.333 2.578 6.982 4.742l-3.616 1.427a3.265 3.265 0 00-3.266-2.549c-2.03 0-3.621 1.537-3.621 3.95 0 2.414 1.591 3.95 3.621 3.95a3.326 3.326 0 003.346-2.524l3.62 1.451c-.633 2.115-3.042 4.688-7.046 4.688a7.432 7.432 0 01-7.09-4.613 7.434 7.434 0 01-.555-2.927zM153.65 10.701v14.462h-3.756v-1.59a5.588 5.588 0 01-4.443 1.944c-4.169 0-7.186-3.261-7.186-7.565s3.017-7.326 7.186-7.326a5.7 5.7 0 014.443 1.84v-1.755l3.756-.01zm-3.9 7.26c0-2.358-1.496-3.988-3.725-3.988s-3.73 1.7-3.73 3.989c0 2.289 1.56 3.99 3.73 3.99 2.169 0 3.725-1.651 3.725-3.99zM156.941 5.106H161v20.047h-4.059V5.106z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M45.67 26.734l-4.663-11.12c3.037-1.213 5.057-3.75 5.057-7.356 0-5.107-3.9-7.98-9.316-7.98H26.91a.688.688 0 00-.658.5l-7.48 25.821a.866.866 0 00.593 1.077c.08.025.162.036.244.035h25.433a.694.694 0 00.634-.952l-.005-.025z",
    fill: "url(#VR_svg__paint0_radial_224_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.01 27.193l7.545-26.047a.688.688 0 00-.469-.852.863.863 0 00-.19 0H2.385a.688.688 0 00-.689.683.708.708 0 00.04.224l8.837 26.056a.693.693 0 00.653.464h5.107a.698.698 0 00.678-.528z",
    fill: "#5CC4E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "VR_svg__paint0_radial_224_16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-30.06786 8.14109 -8.0719 -29.81236 46 7.188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC4E6",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC4E6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "VR_svg__clip0_224_16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .279)",
    d: "M0 0h161v27.443H0z"
  })))));
}

export default SvgVr;